import React from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "./Firebase/firebase";
import { COLLECTIONS } from "./Firebase/Colection";
import styled, { keyframes, css } from "styled-components";
import image1 from "./assets/1.png";
import image2 from "./assets/2.png";
import image3 from "./assets/3.png";
import image4 from "./assets/4.png";
import image5 from "./assets/5.jpeg";
import image6 from "./assets/6.png";
import image7 from "./assets/7.jpeg";
import image8 from "./assets/8.PNG";
import image9 from "./assets/9.PNG";
import image10 from "./assets/10.jpeg";
import image11 from "./assets/11.jpeg";
import image12 from "./assets/12.jpeg";
import image13 from "./assets/13.jpeg";
import image14 from "./assets/14.jpeg";
import logo from "./assets/logo.png";
import parametre from "./assets/Parametre.png";
import Main from "./assets/Main.png";
import Fleche from "./assets/Fleche.png";
import Reset from "./assets/Reset.png";
import Gold from "./assets/Gold.png";
import { RxLinkedinLogo } from "react-icons/rx";
import { Link } from "react-router-dom";
import Loupe3DView from "./Loupe3DView";
import AnimateInformatique from "./AnimateInformatique";
import prosessuce1 from "./assets/prosessuce1.png";
import prosessuce2 from "./assets/prosessuce2.png";
import prosessuce3 from "./assets/prosessuce3.png";
import prosessuce4 from "./assets/prosessuce4.png";
import prosessuce5 from "./assets/prosessuce5.png";
import BackDesign from "./BackDesign";
import Pucedesign from "./Pucedesign";
import ProjectsShowcase from "./ProjectsShowcase";
import RubiksCube3D from "./RubiksCube3D";
import LightBeam from "./LightBeam";

const Bosse = styled.div`
  background-color: rgb(255, 251, 245);
`;

const Section1 = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  overflow: hidden;

  @media (max-width: 500px) {
    flex-direction: column;
    width: 100vw;
    height: auto;
  }
`;

const BouleHombre = styled.div`
  width: 200px;
  height: 200px;
  background-color: #7810c2;
  border-radius: 50%;
  position: absolute;
  top: -30px;
  right: 200px;
  opacity: 0.3;
  filter: blur(10px);

  @media (max-width: 500px) {
    filter: blur(0px);
    opacity: 0.1;
    top: -50px;
    left: -20px;
    width: 250px;
    height: 250px;
  }
`;

const BouleHombre2 = styled.div`
  width: 400px;
  height: 400px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  bottom: 0px;
  left: 10px;
  opacity: 0.6;
  filter: blur(10px);

  @media (max-width: 500px) {
    filter: blur(0px);
    opacity: 0.1;
    top: 0px;
    width: 250px;
    height: 250px;
  }
`;

const Container = styled.div`
  width: 1100px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;

  @media (max-width: 500px) {
    width: 100vw;
    height: auto;
    padding: 20px;
    box-sizing: border-box;
  }
`;

const Navigation = styled.div`
  width: 100%;
  height: 130px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  z-index: 1;
  padding-top: 30px;

  @media (max-width: 500px) {
    width: 100vw;
    height: 10vh;
    top: 0;
    left: 0;
    padding-top: 0px;
  }
`;

const Logo = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 50%;
  }

  @media (max-width: 500px) {
    margin-left: 10px;
    height: 10vh;
  }
`;

const NavigationContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  @media (max-width: 500px) {
    width: 300px;
    justify-content: flex-end;
    padding-right: 20px;
  }
`;

const ButtonContacte2 = styled.button`
  width: 200px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: black;
  background: none;
  border: none;

  cursor: pointer;

  @media (max-width: 500px) {
    font-size: 13px;
    width: fit-content;
    margin-right: 10px;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.9);
    padding: 10px;
  }
`;

const ButtonContacte = styled.button`
  width: 200px;
  height: 70px;
  background-color: orange;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: 800;
  color: white;
  z-index: 1;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 0px 10px rgba(255, 255, 255, 0.9);

  &:active {
    background-color: #000;
    color: #fff;
  }
  &:focus {
    outline: none;
  }

  @media (max-width: 500px) {
    width: 140px;
    height: 50px;
    font-size: 16px;
  }
`;

const CenterPage = styled.div`
  width: 100%;
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  margin-top: 50px;

  @media (max-width: 500px) {
    flex-direction: column;
    width: 100vw;
    height: 100%;
    padding: 20px;
    margin: 0;
  }
`;

const TitlePage = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-direction: column;
  font-size: 45px;
  font-weight: 800;
  color: black;
  font-family: "SpaceGrotesk-Bold", "Inter", "Segoe UI", sans-serif;
  letter-spacing: -0.5px;
  

    @media (max-width: 500px) {
width: 100%;
height: auto;


    }
  }
`;

// --- Keyframes (Animations) ---
const scanLine = keyframes`
  0% { transform: translateY(0%); }
  100% { transform: translateY(100%); }
`;

const neonFlicker = keyframes`
  0%, 19%, 21%, 23%, 25%, 54%, 56%, 100% {
    text-shadow: 0 0 4px #fff, 0 0 11px #CF95F9, 0 0 19px #CF95F9, 0 0 40px #CF95F9;
  }
  20%, 24%, 55% {        
    text-shadow: none;
    color: #0d0d2b;
  }
`;

const gradientShift = keyframes`
  0% { background-position: 0% 50%; }
  100% { background-position: 100% 50%; }
`;

const TitlePresente = styled.h1`
  font-size: 50px;
  font-weight: 700;
  margin-bottom: 50px;
  font-family: "Inter", "Inter-Regular", "SF Pro Text", "Segoe UI", sans-serif;
  line-height: 1.3;
  letter-spacing: 0.2px;
  color: rgba(43, 42, 42, 0.9);

  @media (max-width: 500px) {
    font-size: 30px;
    margin-bottom: 15px;
  }
`;

const SubTitlePage = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  font-size: 20px;
  font-weight: 400;
  color: rgba(43, 42, 42, 0.75);
  font-family: "Inter", "Inter-Regular", "SF Pro Text", "Segoe UI", sans-serif;
  line-height: 1.4;
  letter-spacing: 0.2px;

  @media (max-width: 500px) {
    font-size: 16px;
    color: rgba(43, 42, 42, 0.75);
    width: 100%;
    line-height: 1.2;
    letter-spacing: 0.2px;
    font-weight: 500;
    overflow: hidden;
  }
`;

const CenterRight = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  @media (max-width: 500px) {
    width: 300px;
    height: 300px;
  }
`;

const highlightTextAnim1 = keyframes`
  0%,
  25%,
  90%,
  100% {
    opacity: 1;
  }
  26%,
  89% {
    opacity: 0;
  }
`;

const highlightTextAnim3 = keyframes`
  0%,
  29%,
  56%,
  100% {
    opacity: 0;
  }
  30%,
  55% {
    opacity: 1;
  }
`;

const highlightTextAnim2 = keyframes`
  0%,
  59%,
  86%,
  100% {
    opacity: 0;
  }
  60%,
  85% {
    opacity: 1;
  }
`;

const HighlightText = styled.div`
  position: absolute;
  top: 70%;
  left: 40%;
  width: 150px;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 1;
  padding: 12px 20px;
  border-radius: 18px;
  margin-top: 6px;

  @media (max-width: 500px) {
    top: 60%;
    left: 45%;
  }
`;

const HighlightTextLine = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  font-size: 15px;
  font-weight: 600;
  color: black;
  letter-spacing: 0.01em;
  opacity: 0;
  animation-fill-mode: both;
  font-weight: 800;

  @media (max-width: 500px) {
    font-size: 12px;
  }
`;

const HighlightTextLine1 = styled(HighlightTextLine)`
  animation: ${highlightTextAnim1} 12s infinite ease-in-out;
`;

const HighlightTextLine2 = styled(HighlightTextLine)`
  animation: ${highlightTextAnim2} 12s infinite ease-in-out;
`;

const HighlightTextLine3 = styled(HighlightTextLine)`
  animation: ${highlightTextAnim3} 12s infinite ease-in-out;
`;

// Animations pour faire tourner les 3 images sur un triangle
// Règle demandée :
// - quand une image est en bas à gauche, elle est légèrement plus grande
// - pendant le déplacement bas droite -> bas gauche elle grossit
// - pendant le déplacement bas gauche -> haut centre elle revient à sa taille normale
const triangleAnim1 = keyframes`
  0%,
  20% {
    bottom: 40px;
    left: 40px;   /* position A (bas gauche) */
    transform: scale(1.25);
  }
  30% {
    bottom: 200px;
    left: 200px;  /* position B (haut centre) */
    transform: scale(1);
  }
  50% {
    bottom: 200px;
    left: 200px;
    transform: scale(1);
  }
  60% {
    bottom: 40px;
    left: 360px;  /* position C (bas droite) */
    transform: scale(1);
  }
  80% {
    bottom: 40px;
    left: 360px;
    transform: scale(1);
  }
  90% {
    bottom: 40px;
    left: 40px;
    transform: scale(1.25);
  }
  100% {
    bottom: 40px;
    left: 40px;
    transform: scale(1.25);
  }
`;

const triangleAnim2 = keyframes`
  0%,
  20% {
    bottom: 200px;
    left: 200px;  /* démarre en haut (position B) */
    transform: scale(1);
  }
  30% {
    bottom: 40px;
    left: 360px;  /* va en bas droite (position C) */
    transform: scale(1);
  }
  50% {
    bottom: 40px;
    left: 360px;
    transform: scale(1);
  }
  60% {
    bottom: 40px;
    left: 40px;   /* va en bas gauche (position A) */
    transform: scale(1.25);
  }
  80% {
    bottom: 40px;
    left: 40px;
    transform: scale(1.25);
  }
  90% {
    bottom: 200px;
    left: 200px;  /* revient en haut (position B) */
    transform: scale(1);
  }
  100% {
    bottom: 200px;
    left: 200px;
    transform: scale(1);
  }
`;

const triangleAnim3 = keyframes`
  0%,
  20% {
    bottom: 40px;
    left: 360px;  /* démarre en bas droite (position C) */
    transform: scale(1);
  }
  30% {
    bottom: 40px;
    left: 40px;   /* va en bas gauche (position A) */
    transform: scale(1.25);
  }
  50% {
    bottom: 40px;
    left: 40px;
    transform: scale(1.25);
  }
  60% {
    bottom: 200px;
    left: 200px;  /* va en haut (position B) */
    transform: scale(1);
  }
  80% {
    bottom: 200px;
    left: 200px;
    transform: scale(1);
  }
  90% {
    bottom: 40px;
    left: 360px;  /* revient en bas droite (position C) */
    transform: scale(1);
  }
  100% {
    bottom: 40px;
    left: 360px;
    transform: scale(1);
  }
`;

const triangleAnimMobile1 = keyframes`
  0%,
  20% {
    bottom: 20px;
    left: 20px;
    transform: scale(1.4);
  }
  30% {
    bottom: 120px;
    left: 120px;
    transform: scale(1);
  }
  50% {
    bottom: 120px;
    left: 120px;
    transform: scale(1);
  }
  60% {
    bottom: 20px;
    left: 220px;
    transform: scale(1);
  }
  80% {
    bottom: 20px;
    left: 220px;
    transform: scale(1);
  }
  90% {
    bottom: 20px;
    left: 20px;
    transform: scale(1.4);
  }
  100% {
    bottom: 20px;
    left: 20px;
    transform: scale(1.4);
  }
`;

const triangleAnimMobile2 = keyframes`
  0%,
  20% {
    bottom: 120px;
    left: 120px;
    transform: scale(1);
  }
  30% {
    bottom: 20px;
    left: 220px;
    transform: scale(1);
  }
  50% {
    bottom: 20px;
    left: 220px;
    transform: scale(1);
  }
  60% {
    bottom: 20px;
    left: 20px;
    transform: scale(1.4);
  }
  80% {
    bottom: 20px;
    left: 20px;
    transform: scale(1.4);
  }
  90% {
    bottom: 120px;
    left: 120px;
    transform: scale(1);
  }
  100% {
    bottom: 120px;
    left: 120px;
    transform: scale(1);
  }
`;

const triangleAnimMobile3 = keyframes`
  0%,
  20% {
    bottom: 20px;
    left: 220px;
    transform: scale(1);
  }
  30% {
    bottom: 20px;
    left: 20px;
    transform: scale(1.4);
  }
  50% {
    bottom: 20px;
    left: 20px;
    transform: scale(1.4);
  }
  60% {
    bottom: 120px;
    left: 120px;
    transform: scale(1);
  }
  80% {
    bottom: 120px;
    left: 120px;
    transform: scale(1);
  }
  90% {
    bottom: 20px;
    left: 220px;
    transform: scale(1);
  }
  100% {
    bottom: 20px;
    left: 220px;
    transform: scale(1);
  }
`;

const Image1 = styled.div`
  width: 100px;
  height: 95px;
  position: absolute;
  animation: ${triangleAnim1} 12s infinite ease-in-out;
  border-radius: 40px;
  overflow: hidden;

  img {
    overflow: hidden;

    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 500px) {
    overflow: hidden;

    width: 60px;
    height: 60px;
    animation: ${triangleAnimMobile1} 12s infinite ease-in-out;
  }
`;

const Image2 = styled.div`
  width: 100px;
  height: 100px;
  position: absolute;
  animation: ${triangleAnim2} 12s infinite ease-in-out;
  border-radius: 50%;
  overflow: hidden;
  img {
    overflow: hidden;

    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 500px) {
    width: 60px;
    height: 60px;
    animation: ${triangleAnimMobile2} 12s infinite ease-in-out;
  }
`;

const Image3 = styled.div`
  width: 100px;
  height: 100px;
  position: absolute;
  animation: ${triangleAnim3} 12s infinite ease-in-out;
  border-radius: 20px;
  overflow: hidden;
  img {
    overflow: hidden;

    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 500px) {
    width: 60px;
    height: 60px;
    animation: ${triangleAnimMobile3} 12s infinite ease-in-out;
  }
`;

const BottomPage = styled.div`
  width: 100%;
  height: 200px;
  background-color: #7810c2;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  position: absolute;
  bottom: 0;
  left: 0;

  @media (max-width: 500px) {
    position: relative;
    justify-content: flex-start;
    padding-top: 20px;
    gap: 10px;
  }
`;

const CubeContainer = styled.div`
  height: 10vw;
  width: 100vw;
  position: absolute;
  top: 0;
`;

const CubeContainer2 = styled.div`
  height: 10vw;
  width: 100vw;
  position: absolute;
  bottom: 199px;
  rotate: 180deg;
`;

const cubeAppear = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const Cube = styled.div`
  background: ${(props) => props.$bg || "rgb(255, 251, 245)"};
  height: ${(props) => props.$height || "3vw"};
  width: ${(props) => props.$width || "3vw"};
  position: absolute;
  top: ${(props) => props.$top || "0"};
  left: ${(props) => props.$left || "auto"};
  right: ${(props) => props.$right || "auto"};
  bottom: ${(props) => props.$bottom || "auto"};
  outline: 1px solid ${(props) => props.$bg || "rgb(255, 251, 245)"};
  outline-offset: -1px;
  opacity: 0;
  animation: ${cubeAppear} 0.4s ease forwards;
  animation-delay: ${(props) => props.$delay || "0s"};
`;

const PRDV = styled.p`
  font-size: 30px;
  font-weight: 800;
  color: white;
  z-index: 1;

  @media (max-width: 500px) {
    font-size: 15px;
    text-align: center;
  }
`;

////////////////////////////////////////////////////////// Section 1 //////////////////////////////////////////////////////////

const Section2 = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  position: relative;

  @media (max-width: 500px) {
    width: 100vw;
    height: auto;
    flex-direction: column;
  }
`;

const BackColorRadius = styled.div`
  width: 100%;
  height: 200px;
  background-color: rgb(178, 109, 227);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;

  @media (max-width: 500px) {
    position: relative;
  }
`;

const Title = styled.p`
  font-size: 50px;
  font-weight: 800;
  color: white;
  font-family: "Poppins", sans-serif;
  text-align: center;
  padding: 20px;
  margin-top: 250px;

  @media (max-width: 500px) {
    font-size: 28px;
    font-weight: 800;
    color: white;
    margin-top: 100px;
    padding: 0 20px;
  }
`;

const Bull1 = styled.div`
  width: 200px;
  height: 200px;
  background-color: rgb(178, 109, 227);
  border-radius: 50%;
  position: absolute;
  top: 100px;
  left: 200px;

  @media (max-width: 500px) {
    width: 100px;
    height: 100px;
    top: 150px;
    left: 50px;
  }
`;

const Bull2 = styled.div`
  width: 80px;
  height: 80px;
  background-color: rgb(178, 109, 227);
  border-radius: 50%;
  position: absolute;
  top: 340px;
  left: 150px;

  @media (max-width: 500px) {
    width: 50px;
    height: 40px;
    top: 250px;
    left: 170px;
  }
`;

const ContainerFromulaire = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  margin-top: 100px;

  @media (max-width: 500px) {
    margin-top: 3Opx;
    padding: 10px;
    box-sizing: border-box;
  }
`;

const Input = styled.input`
  width: 500px;
  height: 50px;
  border: 1px solid black;
  border-radius: 15px;
  padding: 10px;

  @media (max-width: 500px) {
    width: 100%;
    height: 50px;
  }
`;

const InputMessage = styled.textarea`
  width: 500px;
  height: 100px;
  border: 1px solid black;
  border-radius: 15px;
  padding: 10px;

  @media (max-width: 500px) {
    width: 100%;
    height: 100px;
  }
`;

const ButtonSubmit = styled.button`
  width: 500px;
  height: 50px;
  border: 1px solid black;
  border-radius: 15px;
  padding: 10px;
  background-color: orange;
  font-size: 16px;
  font-weight: 800;
  color: black;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background-color: yellow;
    color: black;
  }
  &:active {
    background-color: #000;
    color: #fff;
  }
  &:focus {
    outline: none;
  }

  @media (max-width: 500px) {
    width: 100%;
    height: 50px;
    font-size: 16px;
  }
`;

////////////////////////////////////////////////////////// Section 2 //////////////////////////////////////////////////////////

const Section3 = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  position: relative;
  background: #7810c2;
`;

const ContainerSection3 = styled.div`
  width: 1100px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

const TitreSection3 = styled.p`
  font-size: 50px;
  font-weight: 800;
  color: black;
  margin-bottom: 50px;
  color: white;

  @media (max-width: 500px) {
    font-size: 28px;
    font-weight: 800;
    color: white;
    margin-bottom: 50px;
    padding: 0 20px;
  }
`;

const SectionTech = styled.div`
  width: 100vw;
  padding: 60px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  background: linear-gradient(to bottom, #0a075c, #7810c2, rgb(178, 109, 227));
  position: relative;
  z-index: 1;
  overflow: hidden;
`;

const ContainerTech = styled.div`
  width: 1100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  z-index: 10;
  height: auto;
  margin-bottom: 100px;

  @media (max-width: 500px) {
    width: 100vw;
    padding: 0px;
    gap: 24px;
  }
`;

const SectionTechDescription = styled.p`
  max-width: 780px;
  text-align: center;
  color: rgba(255, 255, 255, 0.85);
  font-size: 18px;
  line-height: 1.6;
  margin: 0;

  @media (max-width: 500px) {
    padding: 0 30px;
  }
`;

const TechGrid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: center;
  justify-content: center;
  height: auto;
  background: rgba(255, 255, 255, 0.1);
  padding: 20px;
  border-radius: 40px;

  @media (max-width: 500px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: auto;
    padding: 30px 10px;
    box-sizing: border-box;
    background: inherit;
  }
`;

const TechCard = styled.div`
  background: #ffffff;
  border-radius: 28px;
  padding: 28px;
  box-sizing: border-box;
  border: 1px solid rgba(120, 16, 194, 0.35);
  position: relative;
  z-index: 10;
  height: auto;

  @media (max-width: 500px) {
    height: auto;
  }
`;

const TechCardTitle = styled.h3`
  font-size: 22px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 10px;
  z-index: 10;
`;

const TechList = styled.div`
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
`;

const TechListItem = styled.p`
  font-size: 15px;
  line-height: 1.6;
  border: 2px solid purple;
  padding: 10px;
  border-radius: 20px;
`;

const TechCardDescription = styled.p`
  margin: 0;
  color: #4b5563;
  font-size: 15px;
  line-height: 1.5;
`;

const PucedesignWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const RotatedPucedesign = styled(Pucedesign)`
  width: 160px;
  transform: rotate(90deg);
  position: relative;
`;

const ContainerDesignImage = styled.div`
  position: relative;
  padding: 0 7px;

  @media (max-width: 500px) {
    width: 100vw;
  }
`;

const ContainerTubeLeft = styled.div`
  @media (max-width: 500px) {
    position: absolute;
    top: 20px;
    left: 0;
    width: 17px;
    height: 250px;
    background-color: gray;
    border: 1px solid white;
    border-left: none;
  }
`;
const ContainerTubeRight = styled.div`
  @media (max-width: 500px) {
    position: absolute;
    top: 20px;
    right: 0;
    width: 17px;
    height: 250px;
    background-color: gray;
    border: 1px solid white;
    border-right: none;
  }
`;

const ContainerImagesProject = styled.div`
  width: 100%;
  max-width: 900px;
  overflow: hidden;
  margin-top: 40px;
  margin-inline: auto;
  height: 300px;
  position: relative;
  padding-top: 15px;

  @media (max-width: 500px) {
    width: 90vw;

`;

const LineLeft = styled.div`
  width: 15px;
  height: 300px;
  background-color: white;
  border-radius: 40%;
  position: absolute;
  top: 20px;
  left: 0px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 10;

  @media (max-width: 500px) {
    width: 10px;
    height: 250px;
    left: 12px;
  }
`;

const LineLeftBlack = styled.div`
  width: 70%;
  height: 98%;
  background-color: black;
  border-radius: 40%;
`;

const ComponentLineRight = styled.div`
  position: absolute;
  top: 20px;
  right: 0;
  width: 150px;
  height: 300px;
  background-color: gray;
  border-radius: 0%;
`;

const LineRightBlack = styled.div`
  width: 70%;
  height: 98%;
  background-color: black;
  border-radius: 40%;
`;

const LineRight = styled.div`
  width: 15px;
  height: 300px;
  background-color: white;
  border-radius: 40%;
  position: absolute;
  top: 20px;
  right: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 10;

  @media (max-width: 500px) {
    width: 10px;
    height: 250px;
    right: 12px;
  }
`;

const SliderTrack = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 100px;
  min-width: max-content;
  will-change: transform;
`;

const ImageProject = styled.div`
  height: 260px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 0;
  position: relative;
  flex-shrink: 0; /* important */

  @media (max-width: 500px) {
    background: blue;
    height: 200px;
  }
`;

const ProjectImage = styled.img`
  width: ${(props) => (props.$format === "mobile" ? "auto" : "auto")};
  height: ${(props) => (props.$format === "mobile" ? "100%" : "100%")};
  object-fit: cover;
  border-radius: ${(props) => (props.$format === "mobile" ? "12px" : "12px")};
`;

////////////////////////////////////////////////////////// Section 3 //////////////////////////////////////////////////////////

const Section4 = styled.div`
  width: 100vw;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  position: relative;
  background: linear-gradient(to top, #0a075c, #7810c2);
`;

const ContainerSection4 = styled.div`
  width: 1100px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  position: relative;
  padding-top: 50px;

  @media (max-width: 500px) {
    width: 100vw;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
`;

const SoustitreSection4 = styled.p`
  font-size: 20px;
  font-weight: 400;
  color: rgb(206, 206, 206);
  width: 700px;
  text-align: center;

  @media (max-width: 500px) {
    font-size: 16px;
    font-weight: 400;
    color: rgb(206, 206, 206);
    margin-bottom: 50px;
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
    padding: 0 20px;
  }
`;

const pivotMotion = keyframes`
  0% {
    transform: rotate(0deg);
  }
  30% {
    transform: rotate(-5deg);
  }
  70% {
    transform: rotate(3deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

const StepHeadline = styled.p`
  font-size: 20px;
  font-weight: 700;
  color: ${(props) => (props.$featured ? "#ffffff" : "#111827")};
`;

const StepText = styled.p`
  font-size: 15px;
  line-height: 1.6;
  color: ${(props) => (props.$featured ? "rgba(255,255,255,0.95)" : "#4b5563")};

  @media (max-width: 500px) {
    font-size: 14px;
  }
`;

const ProcessStepsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 800px;
  margin-top: 32px;
  padding: 0px 80px 80px 80px;

  @media (max-width: 500px) {
    width: 100%;
    gap: 30px;
    padding: 10px 10px 80px 10px;
    box-sizing: border-box;
  }
`;

const ProcessStepCard = styled.div`
  background: ${(props) =>
    props.$featured ? "linear-gradient(145deg, #0f172a, #2c0a47)" : "#ffffff"};
  border-radius: 20px;
  padding: 32px;
  display: flex;
  flex-direction: row;
  gap: 24px;
  border: 1px solid rgba(120, 16, 194, 0.08);
  align-items: center;
  box-shadow: ${(props) =>
    props.$featured
      ? "0 25px 60px rgba(0, 0, 0, 0.45)"
      : "0 18px 45px rgba(145, 164, 208, 0.4)"};
  opacity: 0;
  transform: ${({ $animationDirection }) =>
    $animationDirection === "right" ? "translateX(60px)" : "translateX(-60px)"};
  transition:
    opacity 0.75s ease,
    transform 0.75s ease;
  &.card-visible {
    opacity: 1;
    transform: translateX(0);
  }

  @media (max-width: 768px) {
    padding: 24px;
    gap: 16px;
  }
`;

const ProcessStepImage = styled.img`
  width: 40%;
  height: 240px;
  border-radius: 18px;
  object-fit: cover;

  @media (max-width: 768px) {
    width: 40%;
    height: 200px;
  }
`;

const ProcessStepContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const StepOrder = styled.span`
  font-size: 12px;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: ${(props) => (props.$featured ? "#f4c430" : "#7810c2")};
`;

////////////////////////////////////////////////////////// Section 4 //////////////////////////////////////////////////////////
const Footer = styled.div`
  width: 100vw;
  height: auto;
  padding: 70px 0;
  background: black;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 500px) {
    padding: 50px 0;
  }
`;
const ContainerFooter = styled.div`
  width: 1100px;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 500px) {
    padding: 20px;
    box-sizing: border-box;
  }
`;
const LogoFooter = styled.div`
  width: 100px;
  height: 100px;
  overflow: hidden;

  img {
    width: 100px;
    height: 100px;
    object-fit: contain;
  }
`;

const ContainerFooter2 = styled.div`
  display: flex;
  flex-direction: row;
`;
const TexteFooter = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: white;
  margin: 0;
`;

const FooterLink = styled(Link)`
  font-size: 16px;
  font-weight: 400;
  color: white;
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  margin: 0;
  &:hover,
  &:focus-visible {
    opacity: 0.8;
  }

  @media (max-width: 500px) {
    font-size: 12px;
  }
`;

const ButtonLinkedin = styled.button`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  background: white;
  padding: 0px;
`;
const Page = () => {
  const [orangeCubePosition, setOrangeCubePosition] = React.useState(null);
  const [showBeam, setShowBeam] = React.useState(false);
  const buttonRef = React.useRef(null);
  const section1Ref = React.useRef(null);

  const handleAnimationComplete = () => {
    console.log("✨ Animation terminée, affichage du rayon");
    setShowBeam(true);
  };

  const cubes = [
    { top: "0", left: "0", width: "3vw", height: "3vw", delay: "0s" },
    { top: "3vw", left: "0", width: "3vw", height: "3vw", delay: "0s" },
    { top: "6vw", left: "0", width: "3vw", height: "3vw", delay: "0s" },
    { top: "0", left: "3vw", width: "3vw", height: "3vw", delay: "0.05s" },
    { top: "3vw", left: "3vw", width: "3vw", height: "3vw", delay: "0.05s" },
    { top: "0", left: "6vw", width: "3vw", height: "3vw", delay: "0.1s" },
    { top: "3vw", left: "6vw", width: "3vw", height: "3vw", delay: "0.1s" },
    { top: "0", left: "9vw", width: "3vw", height: "3vw", delay: "0.15s" },
    { top: "0", left: "12vw", width: "3vw", height: "3vw", delay: "0.2s" },
    { top: "0", left: "15vw", width: "3vw", height: "3vw", delay: "0.25s" },
    { top: "0", left: "21vw", width: "3vw", height: "3vw", delay: "0.3s" },
    { top: "0", left: "24vw", width: "3vw", height: "3vw", delay: "0.35s" },
    { top: "3vw", left: "24vw", width: "3vw", height: "3vw", delay: "0.35s" },
    { top: "0", left: "27vw", width: "3vw", height: "3vw", delay: "0.4s" },
  ];

  const cubesViolet = [
    {
      top: "0",
      left: "0",
      width: "3vw",
      height: "3vw",
      bg: "#7810c2",
      delay: "1.0s",
    },
    {
      top: "3vw",
      left: "0",
      width: "3vw",
      height: "3vw",
      bg: "#7810c2",
      delay: "1.0s",
    },
    {
      top: "6vw",
      left: "0",
      width: "3vw",
      height: "3vw",
      bg: "#7810c2",
      delay: "1.0s",
    },
    {
      top: "0",
      left: "3vw",
      width: "3vw",
      height: "3vw",
      bg: "#7810c2",
      delay: "0.95s",
    },
    {
      top: "3vw",
      left: "3vw",
      width: "3vw",
      height: "3vw",
      bg: "#7810c2",
      delay: "0.95s",
    },
    {
      top: "0",
      left: "6vw",
      width: "3vw",
      height: "3vw",
      bg: "#7810c2",
      delay: "0.9s",
    },
    {
      top: "3vw",
      left: "6vw",
      width: "3vw",
      height: "3vw",
      bg: "#7810c2",
      delay: "0.9s",
    },
    {
      top: "0",
      left: "9vw",
      width: "3vw",
      height: "3vw",
      bg: "#7810c2",
      delay: "0.85s",
    },
    {
      top: "0",
      left: "12vw",
      width: "3vw",
      height: "3vw",
      bg: "#7810c2",
      delay: "0.8s",
    },
    {
      top: "0",
      left: "15vw",
      width: "3vw",
      height: "3vw",
      bg: "#7810c2",
      delay: "0.75s",
    },
    {
      top: "0",
      left: "21vw",
      width: "3vw",
      height: "3vw",
      bg: "#7810c2",
      delay: "0.7s",
    },
    {
      top: "0",
      left: "24vw",
      width: "3vw",
      height: "3vw",
      bg: "#7810c2",
      delay: "0.65s",
    },
    {
      top: "3vw",
      left: "24vw",
      width: "3vw",
      height: "3vw",
      bg: "#7810c2",
      delay: "0.65s",
    },
    {
      top: "0",
      left: "27vw",
      width: "3vw",
      height: "3vw",
      bg: "#7810c2",
      delay: "0.6s",
    },
  ];

  const initialProjects = [
    { src: image1, format: "desktop" },
    { src: image2, format: "desktop" },
    { src: image3, format: "mobile" },
    { src: image4, format: "mobile" },
    { src: image5, format: "mobile" },
    { src: image6, format: "mobile" },
    { src: image7, format: "desktop" },
    { src: image8, format: "desktop" },
    { src: image9, format: "desktop" },
    { src: image10, format: "desktop" },
    { src: image11, format: "desktop" },
    { src: image12, format: "desktop" },
    { src: image13, format: "desktop" },
    { src: image14, format: "desktop" },
  ];

  const INFINITE_LIST = React.useMemo(
    () => [...initialProjects, ...initialProjects],
    [],
  );
  const trackRef = React.useRef(null);

  React.useEffect(() => {
    const speed = 1;
    let scrollPosition = 0;
    let raf;

    const animate = () => {
      const track = trackRef.current;
      if (!track) {
        raf = requestAnimationFrame(animate);
        return;
      }

      const trackWidth = track.scrollWidth / 2;
      scrollPosition += speed;
      if (scrollPosition >= trackWidth) {
        scrollPosition = 0;
      }

      track.style.transform = `translateX(-${scrollPosition}px)`;
      raf = requestAnimationFrame(animate);
    };

    raf = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(raf);
  }, []);

  // Slider projets (carousel infini, sans "freeze")
  const [projects, setProjects] = React.useState(initialProjects);
  const [translateX, setTranslateX] = React.useState(0);
  const [isTransitioning, setIsTransitioning] = React.useState(false);
  const [cardWidth, setCardWidth] = React.useState(0);

  const [nom, setNom] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [entreprise, setEntreprise] = React.useState("");
  const [telephone, setTelephone] = React.useState("");
  const [typeProjet, setTypeProjet] = React.useState("");
  const [budget, setBudget] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [success, setSuccess] = React.useState(false);

  // Étapes du process de développement
  const steps = [
    {
      label: "Comprendre votre besoin",
      text: "Nous échangeons avec vous pour comprendre vos objectifs, votre activité et vos contraintes. Ensemble, nous définissons le périmètre, les fonctionnalités prioritaires et la vision globale du projet.",
      image: prosessuce1,
    },
    {
      label: "Créer la structure",
      text: "Nous élaborons la structure fonctionnelle et technique du projet, réalisons les maquettes, puis validons chaque étape avec vous. L’objectif : être alignés sur le rendu final avant le développement.",
      image: prosessuce2,
    },
    {
      label: "Développer la solution",
      text: "Nous développons votre projet avec les meilleures pratiques et technologies de sort a avoir un code scalable et maintenable sur le long terme.",
      image: prosessuce4,
    },
    {
      label: "Mise en production",
      text: "Une fois validé, votre projet est déployé en production. Nous nous assurons que tout fonctionne parfaitement dans l’environnement cible et restons disponibles pour vous accompagner après la mise en ligne.",
      image: prosessuce5,
    },
  ];

  // Mesurer dynamiquement la largeur d'une card (pour un slide propre)
  React.useEffect(() => {
    if (!trackRef.current) return;
    const firstCard = trackRef.current.querySelector("[data-card]");
    if (firstCard) {
      const rect = firstCard.getBoundingClientRect();
      // largeur + gap (24px) pour que le slide se fasse carte par carte
      setCardWidth(rect.width + 24);
    }
  }, []);

  // Lance le premier slide une fois qu'on connaît la largeur
  React.useEffect(() => {
    if (!cardWidth) return;
    // on démarre le mouvement après le premier render
    requestAnimationFrame(() => {
      setIsTransitioning(true);
      setTranslateX(-cardWidth);
    });
  }, [cardWidth]);

  React.useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof IntersectionObserver === "undefined"
    ) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("card-visible");
          } else {
            entry.target.classList.remove("card-visible");
          }
        });
      },
      {
        root: null,
        rootMargin: "0px 0px -20% 0px",
        threshold: 0.25,
      },
    );

    const cards = document.querySelectorAll("[data-animate-card]");
    cards.forEach((card) => observer.observe(card));

    return () => {
      observer.disconnect();
    };
  }, []);

  const handleProjectsTransitionEnd = () => {
    if (!cardWidth) return;

    // On fige le mouvement, on remet à 0 et on décale le tableau
    setIsTransitioning(false);
    setTranslateX(0);
    setProjects((prev) => {
      if (prev.length <= 1) return prev;
      const [first, ...rest] = prev;
      return [...rest, first];
    });

    // Puis on relance immédiatement un nouveau slide (sans "freeze" visuel)
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setIsTransitioning(true);
        setTranslateX(-cardWidth);
      });
    });
  };

  const contactSectionRef = React.useRef(null);

  const scrollToContact = () => {
    contactSectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleSubmit = async () => {
    if (!nom || !email || !message) {
      setError("Merci de remplir tous les champs.");
      return;
    }

    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      await addDoc(collection(db, COLLECTIONS.INSCALE), {
        nom,
        email,
        message,
        createdAt: new Date().toISOString(),
        entreprise,
        telephone,
        typeProjet,
        budget,
      });
      setSuccess(true);
      setNom("");
      setEmail("");
      setMessage("");
    } catch (e) {
      console.error(e);
      setError("Une erreur est survenue pendant l'envoi.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Bosse>
      <Section1 id="section-1" ref={section1Ref}>
        {/* <Loupe3DView /> */}

        {/* <BouleHombre /> */}

        <Container>
          <Navigation>
            <Logo>
              <img src={logo} alt="logo" />
            </Logo>
            <NavigationContainer>
              <ButtonContacte2 type="button" onClick={scrollToContact}>
                Contactez-nous
              </ButtonContacte2>
            </NavigationContainer>
          </Navigation>

          <CenterPage>
            <TitlePage>
              <BouleHombre2 />

              <TitlePresente>
                Architectes de vos solutions design et informatiques.
              </TitlePresente>
              <SubTitlePage>
                Inscalup est un studio expert en Design UX/UI et Développement
                informatique. Nous concevons des solutions sur-mesure qui
                transforment vos besoins métiers en produits technologiques
                performants.
              </SubTitlePage>
            </TitlePage>
            <CenterRight>
              <RubiksCube3D
                onOrangeCubePosition={setOrangeCubePosition}
                onAnimationComplete={handleAnimationComplete}
              />
            </CenterRight>
          </CenterPage>
        </Container>
        <CubeContainer2>
          {cubesViolet.map((cube, index) => (
            <Cube
              key={index}
              $top={cube.top}
              $left={cube.left}
              $right={cube.right}
              $bottom={cube.bottom}
              $width={cube.width}
              $height={cube.height}
              $bg={cube.bg}
              $delay={cube.delay}
            />
          ))}
        </CubeContainer2>

        <BottomPage>
          <CubeContainer>
            {cubes.map((cube, index) => (
              <Cube
                key={index}
                $top={cube.top}
                $left={cube.left}
                $right={cube.right}
                $bottom={cube.bottom}
                $width={cube.width}
                $height={cube.height}
                $bg={cube.bg}
                $delay={cube.delay}
              />
            ))}
          </CubeContainer>
          <PRDV>Prendre rendez-vous</PRDV>
          <ButtonContacte
            ref={buttonRef}
            style={{ border: "2px solid white" }}
            type="button"
            onClick={scrollToContact}
          >
            20 min Gratuit
          </ButtonContacte>
        </BottomPage>
        {showBeam && (
          <LightBeam
            orangeCubePosition={orangeCubePosition}
            targetRef={buttonRef}
            containerRef={section1Ref}
          />
        )}
      </Section1>
      {/* //////////////////////////////////////////////////////////// Section 2 //////////////////////////////////////////////////////////// */}

      <Section4 id="section-2">
        {/* <BullWhite1 />
        <BullWhite2 /> */}
        <ContainerSection4>
          <Title>Processus de développement </Title>

          <SoustitreSection4>
            Un accompagnement structuré pour transformer vos idées en solutions
            digitales performantes.
          </SoustitreSection4>
          <AnimateInformatique />

          <ProcessStepsColumn>
            {steps.map((step, index) => {
              const direction = index % 2 === 0 ? "left" : "right";
              const isImageRight = index % 2 === 0;
              const isFeatured = index === steps.length - 1;

              return (
                <ProcessStepCard
                  key={step.label}
                  $featured={isFeatured}
                  $animationDirection={direction}
                  data-animate-card="step"
                  data-step-index={index}
                >
                  {!isImageRight && step.image && (
                    <ProcessStepImage
                      src={step.image}
                      alt={`Illustration étape ${index + 1}`}
                    />
                  )}
                  <ProcessStepContent>
                    <StepOrder $featured={isFeatured}>
                      Étape {index + 1}
                    </StepOrder>
                    <StepHeadline $featured={isFeatured}>
                      {step.label}
                    </StepHeadline>
                    <StepText $featured={isFeatured}>{step.text}</StepText>
                  </ProcessStepContent>
                  {isImageRight && step.image && (
                    <ProcessStepImage
                      src={step.image}
                      alt={`Illustration étape ${index + 1}`}
                    />
                  )}
                </ProcessStepCard>
              );
            })}
          </ProcessStepsColumn>
        </ContainerSection4>
      </Section4>
      {/* //////////////////////////////////////////////////////////// Section 3 //////////////////////////////////////////////////////////// */}

      <SectionTech>
        <ContainerTech>
          <Title>Technos que nous mobilisons</Title>
          <SectionTechDescription>
            Nous utilisons les technologies suivantes pour le développement de
            vos projets en prenant en compte vos besoins et vos contraintes pour
            vous offrir la meilleure solution possible.
          </SectionTechDescription>
          <TechGrid>
            <TechCard>
              <BackDesign />

              <TechCardTitle style={{ color: "white" }}>Design</TechCardTitle>
              <TechCardDescription style={{ color: "white" }}>
                Direction artistique, prototypage et animation pour matérialiser
                vos intentions et valider l’ergonomie avant de produire du code.
              </TechCardDescription>
              <TechList>
                <TechListItem style={{ color: "white", borderColor: "white" }}>
                  Figma
                </TechListItem>
                <TechListItem style={{ color: "white", borderColor: "white" }}>
                  Blender
                </TechListItem>
                <TechListItem style={{ color: "white", borderColor: "white" }}>
                  Photoshop
                </TechListItem>
              </TechList>
            </TechCard>
            <Pucedesign />
            <TechCard>
              <TechCardTitle>Développement</TechCardTitle>
              <TechCardDescription>
                Stacks technologiques utilisées pour le développement de vos
                projets.
              </TechCardDescription>
              <TechList>
                <TechListItem>React.js</TechListItem>
                <TechListItem>Next.js</TechListItem>
                <TechListItem>React Native</TechListItem>
                <TechListItem>TypeScript</TechListItem>
                <TechListItem>Node.js</TechListItem>
                <TechListItem>Express</TechListItem>
                <TechListItem>Firebase / Firestore</TechListItem>
                <TechListItem>GraphQL</TechListItem>
                <TechListItem>PostgreSQL</TechListItem>
              </TechList>
            </TechCard>
          </TechGrid>
        </ContainerTech>
      </SectionTech>
      {/* //////////////////////////////////////////////////////////// Section 4 //////////////////////////////////////////////////////////// */}
      {/* <Section3 id="section-3">
        <ContainerSection3>
          <Title>Nos projets </Title>
          <ContainerDesignImage>
            <LineLeft>
              <LineLeftBlack />
            </LineLeft>
            <LineRight>
              <LineRightBlack />
            </LineRight>
            <ContainerTubeLeft />
            <ContainerTubeRight />

            <ContainerImagesProject>
              <SliderTrack ref={trackRef}>
                {INFINITE_LIST.map((p, index) => (
                  <ImageProject key={`p-${index}`} data-card>
                    <ProjectImage
                      src={p.src}
                      alt="project"
                      $format={p.format}
                    />
                  </ImageProject>
                ))}
              </SliderTrack>
            </ContainerImagesProject>
          </ContainerDesignImage>
        </ContainerSection3>
      </Section3> */}
      <ProjectsShowcase />
      {/* //////////////////////////////////////////////////////////// Section 5 //////////////////////////////////////////////////////////// */}

      <Section2 ref={contactSectionRef}>
        <BackColorRadius>
          <Title style={{ marginTop: "0px" }}>contact</Title>
        </BackColorRadius>
        <Bull1 />
        <Bull2 />
        <Container>
          <ContainerFromulaire>
            <Input
              placeholder="Nom et Prénom"
              value={nom}
              onChange={(e) => setNom(e.target.value)}
            />
            <Input
              placeholder="Entreprise (optionnel)"
              value={entreprise}
              onChange={(e) => setEntreprise(e.target.value)}
            />
            <Input
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input
              placeholder="Téléphone (optionnel)"
              value={telephone}
              onChange={(e) => setTelephone(e.target.value)}
            />
            <Input
              placeholder="Type de projet"
              value={typeProjet}
              onChange={(e) => setTypeProjet(e.target.value)}
            />
            <Input
              placeholder="Budget (optionnel)"
              value={budget}
              onChange={(e) => setBudget(e.target.value)}
            />
            <InputMessage
              placeholder="Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <ButtonSubmit
              type="button"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Envoi..." : "Envoyer"}
            </ButtonSubmit>
            {error && <p>{error}</p>}
            {success && <p>Message envoyé dans Firebase ✅</p>}
          </ContainerFromulaire>
        </Container>
      </Section2>
      <Footer>
        <ContainerFooter>
          <LogoFooter>
            <img src={logo} alt="logo" />
          </LogoFooter>
          <TexteFooter>InScale propulser par GeekVibz</TexteFooter>
          <ContainerFooter2>
            <ButtonLinkedin
              type="button"
              onClick={() =>
                window.open(
                  "https://www.linkedin.com/in/ismail-majdoubi-061700205/",
                  "_blank",
                )
              }
            >
              <RxLinkedinLogo size={30} color="#67A5EB" />
            </ButtonLinkedin>
          </ContainerFooter2>
          <FooterLink to="/privacy">
            Politique de confidentialité – GeekVibz
          </FooterLink>
          <FooterLink to="/support">Support – GeekVibz</FooterLink>
        </ContainerFooter>
      </Footer>
    </Bosse>
  );
};

export default Page;
